import { render, staticRenderFns } from "./MSDLN2024.vue?vue&type=template&id=5325e3b0&scoped=true"
import script from "./MSDLN2024.vue?vue&type=script&lang=js"
export * from "./MSDLN2024.vue?vue&type=script&lang=js"
import style0 from "./MSDLN2024.vue?vue&type=style&index=0&id=5325e3b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5325e3b0",
  null
  
)

export default component.exports